import { render, staticRenderFns } from "./listagem-de-produto.html?vue&type=template&id=07534879&scoped=true&"
import script from "./listagem-de-produto.vue?vue&type=script&lang=js&"
export * from "./listagem-de-produto.vue?vue&type=script&lang=js&"
import style0 from "./listagem-de-produto.less?vue&type=style&index=0&id=07534879&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07534879",
  null
  
)

export default component.exports